import consumer from './consumer';

let analyticsChatSubscription = null;

export function subscribeTo(conversationId) {
  if (analyticsChatSubscription) {
    analyticsChatSubscription.unsubscribe();
  }

  analyticsChatSubscription = consumer.subscriptions.create(
    { channel: 'AnalyticsChatChannel', conversation_id: conversationId },
    {
      received(data) {
        if (data.type === 'status') {
          document.dispatchEvent(
            new CustomEvent('analytics-chat:status', { detail: data })
          );
        }

        if (data.type === 'message') {
          document.dispatchEvent(
            new CustomEvent('analytics-chat:message', { detail: data })
          );
        }
      }
    }
  );

  return analyticsChatSubscription;
}

export default { subscribeTo };
